import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Website } from 'src/app/client/website';
import { SoftwareService } from '../../../software-services/software-service';
import { AuthenticationService } from '../../../user/authentication.service';

@Component({
    selector: 'thumbnail-button',
    templateUrl: './thumbnail-button.component.html',
    styleUrls: ['./thumbnail-button.component.scss'],
    standalone: false
})
export class ThumbnailButtonComponent implements OnInit {
    @Input() label: string;
    @Input() backgroundImage: string;
    @Input() link: string;
    @Input() softwareService: SoftwareService;
    @Input() website: Website = new Website();
    @Input() error: string;
    @Input() warning: string;
    @Input() isComingSoon: boolean;
    @Input() hasSettings: boolean;

  constructor(private router: Router, private auth: AuthenticationService) { }

    ngOnInit(): void {
    }

    action() {
      if (this.isComingSoon) {
        alert('Coming Soon!');
        return;
      }

      if (this.softwareService && !this.softwareService.isEnabled && !this.auth.getCurrentUser().isEmployee) {
        //jeb todo UI/UX
        alert('service isnt enabled / show teaser or maybe route to the service page?');
        return;
      }

      if (this.error) {
        //jeb todo UI/UX
        alert(this.error);
        return;
      }
    
      this.router.navigate([this.link]);
    }

    goToSettings() {
      this.router.navigate([this.link + '/settings']);
    }
}
